/** Keep the screen on while the engine runs; re-acquire when the tab returns. */
type WakeLockSentinelLike = { release(): Promise<void>; addEventListener?: (t: string, cb: () => void) => void };

let sentinel: WakeLockSentinelLike | null = null;
let wanted = false;

export async function requestWakeLock(): Promise<boolean> {
  wanted = true;
  const nav = navigator as Navigator & { wakeLock?: { request(type: 'screen'): Promise<WakeLockSentinelLike> } };
  if (!nav.wakeLock) return false;
  try {
    sentinel = await nav.wakeLock.request('screen');
    return true;
  } catch {
    return false;
  }
}

export function releaseWakeLock(): void {
  wanted = false;
  void sentinel?.release().catch(() => undefined);
  sentinel = null;
}

export function isWakeLockActive(): boolean {
  return sentinel !== null;
}

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (wanted && document.visibilityState === 'visible' && !sentinel) void requestWakeLock();
  });
}
